// src/utils/dateUtils.js
import * as dateFns from 'date-fns';

export const convertUTCToLocal = (utcDateString) => {
  const utcDate =
    typeof utcDateString === 'string' ? new Date(utcDateString) : utcDateString;
  return new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60 * 1000);
};

export const convertLocalToUTC = (localDate) => {
  return new Date(
    localDate.getTime() - localDate.getTimezoneOffset() * 60 * 1000,
  );
};

export const getMondayOfWeek = (date = new Date()) =>
  dateFns.startOfWeek(date, { weekStartsOn: 1 });

export const getSundayOfWeek = (date) =>
  dateFns.endOfWeek(date, { weekStartsOn: 1 });

export const formatDate = (date) => {
  return dateFns.format(date, 'yyyy-MM-dd');
};

// Verify a date is a Monday
export const isMonday = (date) => dateFns.isMonday(date);

export const getListWeekOfMonths = (date = new Date()) => {
  const startOfMonth = dateFns.startOfMonth(date);
  const endOfMonth = dateFns.endOfMonth(date);

  const startWeek = getMondayOfWeek(startOfMonth);
  const endWeek = getMondayOfWeek(endOfMonth);

  const listWeek = [];
  let currentWeek = startWeek;

  while (currentWeek <= endWeek) {
    listWeek.push(currentWeek);
    currentWeek = dateFns.addWeeks(currentWeek, 1);
  }

  return listWeek;
};

export const getMonthWeeks = (today = new Date()) => {
  const weeks = [];
  const listWeek = getListWeekOfMonths(today);

  listWeek.forEach((week, i) => {
    const weekStart = getMondayOfWeek(week);
    const weekEnd = getSundayOfWeek(week);
    const weekNumber = dateFns.getWeek(weekStart);

    // check weekStart in current month
    const isCurrentMonth = dateFns.isSameMonth(weekStart, today);
    if (!isCurrentMonth) {
      return;
    }

    const isCurrentWeek = dateFns.isSameWeek(weekStart, today);

    weeks.push({
      startDate: weekStart.toISOString(),
      endDate: weekEnd.toISOString(),
      weekNumber,
      isCurrent: isCurrentWeek,
      key: formatDate(weekStart),
      displayDates: `${formatDate(weekStart)} - ${formatDate(weekEnd)}`,
    });
  });

  return weeks.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
};

export const getCurrentQuarter = (now = new Date()) => {
  const year = now.getFullYear();
  const month = now.getMonth();

  const quarter = Math.floor(month / 3);
  const startMonth = quarter * 3;

  const start = new Date(year, startMonth, 1);
  const end = new Date(year, startMonth + 3, 0);
  return { start, end };
};
